/* eslint-disable react-hooks/exhaustive-deps */
import {Box} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {IProductItem} from '@wearesection/bandai-react-components/organisms/EStoreProduct/ProductItem';
import EStoreProductDetailRecently from '@wearesection/bandai-react-components/organisms/EStoreProductDetailRecently';
import {usePageSetting} from '~/providers/page-context.provider';
import productsApi from '~/pages/api/services/products-api';
import {handleFormatProducts} from '~/pages/store/games/index.page';
import cookie from 'js-cookie';
import {cloneDeep} from 'lodash';
import {GetRouter, handleConvertToLocaleContentful} from '~/utils';

type IProps = {
  loading?: boolean;
};
const EStoreProductDetailRecentlyOrganisms: React.FC<IProps> = ({loading}) => {
  const isLogged = cookie.get('isLoginSuccess');
  const token = cookie.get('token');
  const {locale} = GetRouter();

  const {globalData} = usePageSetting();
  const dataTranslation = globalData?.dataTranslation?.[0] ?? {};

  const productListRecentlyID = useSelector(
    (state: any) => state?.productListRecently?.productListRecentlyID ?? []
  );
  const [productListRecently, setProductListRecently] = useState<IProductItem[]>([]);

  const handleSortProduct = (productList: any[], productID: any[]) => {
    const result: any[] = [];
    productID.map((item: any) => {
      const product = productList.find((p: any) => `${p.id}` === item || p.id === item);
      result.push(product);
    });
    return result.filter((item: any) => !!item);
  };

  useEffect(() => {
    if (typeof window !== 'undefined' && Object.keys(dataTranslation)?.length) {
      try {
        if (!productListRecentlyID?.length) return;
        productsApi
          .getListProductsForId(
            productListRecentlyID.join(),
            handleConvertToLocaleContentful(locale as string)
          )
          .then((res: any) => {
            if (res?.status !== 200) {
              throw res;
            }
            const data = res?.data?.data || [];
            const productsFormat = handleFormatProducts(data, dataTranslation || {}, locale);
            const newProductList = handleSortProduct(productsFormat, productListRecentlyID);

            setProductListRecently(newProductList);
          });
      } catch (error) {
        console.log(error);
      }
    }
  }, [productListRecentlyID, dataTranslation]);

  useEffect(() => {
    if (isLogged) {
      productsApi.updateListIdRecentlyViewed(
        {
          products_id: cloneDeep(productListRecentlyID).splice(0, 10),
        },
        token
      );
    }
  }, [isLogged, productListRecentlyID, token]);

  return (
    <Box
      sx={{
        background: '#F9F9F9',
        padding: {
          xs: '72px 0px',
          md: '40px 0px',
        },
      }}
    >
      {!!productListRecently?.length && !loading && (
        <EStoreProductDetailRecently
          title={dataTranslation['estore-products-detail-title-recently-viewed']}
          productList={productListRecently}
          locale={`${locale}`.toLowerCase()}
        />
      )}
    </Box>
  );
};

export default EStoreProductDetailRecentlyOrganisms;
